// extracted by mini-css-extract-plugin
export default {"conditionalCheckmark":"conditionalCheckmark__NzUwZ"};